var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_576_2849",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_576_2849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 19.5H13V18.5H14C14.2833 18.5 14.5208 18.4042 14.7125 18.2125C14.9042 18.0208 15 17.7833 15 17.5V14.5C15 14.2167 14.9042 13.9792 14.7125 13.7875C14.5208 13.5958 14.2833 13.5 14 13.5H11V12.5H15V10.5H13V9.5H11V10.5H10C9.71667 10.5 9.47917 10.5958 9.2875 10.7875C9.09583 10.9792 9 11.2167 9 11.5V14.5C9 14.7833 9.09583 15.0208 9.2875 15.2125C9.47917 15.4042 9.71667 15.5 10 15.5H13V16.5H9V18.5H11V19.5ZM6 22.5C5.45 22.5 4.97917 22.3042 4.5875 21.9125C4.19583 21.5208 4 21.05 4 20.5V4.5C4 3.95 4.19583 3.47917 4.5875 3.0875C4.97917 2.69583 5.45 2.5 6 2.5H14L20 8.5V20.5C20 21.05 19.8042 21.5208 19.4125 21.9125C19.0208 22.3042 18.55 22.5 18 22.5H6ZM13 8.5V4.5H6V20.5H18V8.5H13Z",
    fill: "#1C1C1C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.74fee9d47873d313b433c1c759b5e670.svg";
export { ForwardRef as ReactComponent };